import api from '../../plugins/api';

const editServiceRecord = (params) => {
  return api.post('/api/crm/services/editService', params);
};

export default editServiceRecord;
